import { JourneyFeatures } from '@app/infrastructure/data/journey-features';

// export const STP = '';

// export const LOAD_POLICY = JourneyFeatures.loadPolicy.path;

// export const BILLING = JourneyFeatures.billing.path;

// export const RETRIEVE_QUOTE = JourneyFeatures.retrieveQuote.path;

export const CHANGE_TYPE = JourneyFeatures.changeType.path;
export const CHANGE_TYPE_ROUTE = `/${CHANGE_TYPE}`;
export const CHANGE_DATE = JourneyFeatures.changeDate.path;
export const CHANGE_DATE_ROUTE = `/${CHANGE_DATE}`;

export const DASHBOARD_SELECT = JourneyFeatures.dashboardSelect.path;
export const DASHBOARD_SELECT_ROUTE = `/${DASHBOARD_SELECT}`;
export const DASHBOARD_UPDATE = JourneyFeatures.dashboardUpdate.path;
export const DASHBOARD_UPDATE_ROUTE = `/${DASHBOARD_UPDATE}`;

export const RENEWAL_PREFERENCE = JourneyFeatures.renewalPreference.path;
export const RENEWAL_PREFERENCE_ROUTE = `/${RENEWAL_PREFERENCE}`;

export const YOUR_CAR_PERM = JourneyFeatures.yourCarPerm.path;
export const YOUR_CAR_PERM_ROUTE = `/${YOUR_CAR_PERM}`;

export const YOUR_CAR_TEMP = JourneyFeatures.yourCarTemp.path;
export const YOUR_CAR_TEMP_ROUTE = `/${YOUR_CAR_TEMP}`;

export const YOUR_TEMPORARY_EUROPEAN_COVER = JourneyFeatures.yourTemporaryEuropeanCover.path;
export const YOUR_TEMPORARY_EUROPEAN_COVER_ROUTE = `/${YOUR_TEMPORARY_EUROPEAN_COVER}`;

export const YOUR_MILEAGE = JourneyFeatures.yourMileage.path;
export const YOUR_MILEAGE_ROUTE = `/${YOUR_MILEAGE}`;

export const YOUR_DETAILS = JourneyFeatures.yourDetails.path;
export const YOUR_DETAILS_ROUTE = `/${YOUR_DETAILS}`;

export const YOUR_REGISTRATION = JourneyFeatures.yourRegistration.path;
export const YOUR_REGISTRATION_ROUTE = `/${YOUR_REGISTRATION}`;

export const YOUR_DRIVERS_PERM = JourneyFeatures.yourDriversPerm.path;
export const YOUR_DRIVERS_PERM_ROUTE = `/${YOUR_DRIVERS_PERM}`;

export const YOUR_DRIVERS_TEMP = JourneyFeatures.yourDriversTemp.path;
export const YOUR_DRIVERS_TEMP_ROUTE = `/${YOUR_DRIVERS_TEMP}`;

export const YOUR_DRIVERS_MORE_INFO = JourneyFeatures.yourDriversMoreInfo.path;
export const YOUR_DRIVERS_MORE_INFO_ROUTE = `/${YOUR_DRIVERS_MORE_INFO}`;

export const YOUR_LICENCE_NUMBER = JourneyFeatures.yourLicenceNumber.path;
export const YOUR_LICENCE_NUMBER_ROUTE = `/${YOUR_LICENCE_NUMBER}`;
export const YOUR_DRIVING_HISTORY = JourneyFeatures.yourDrivingHistory.path;
export const YOUR_DRIVING_HISTORY_ROUTE = `/${YOUR_DRIVING_HISTORY}`;

export const YOUR_ADDRESSES = JourneyFeatures.yourAddresses.path;
export const YOUR_ADDRESSES_ROUTE = `/${YOUR_ADDRESSES}`;

export const YOUR_ADDRESS = JourneyFeatures.yourAddress.path;
export const YOUR_ADDRESS_ROUTE = `/${YOUR_ADDRESS}`;

export const YOUR_POSTAL_ADDRESS = JourneyFeatures.yourPostalAddress.path;
export const YOUR_POSTAL_ADDRESS_ROUTE = `/${YOUR_POSTAL_ADDRESS}`;

export const PARKING_DETAILS = JourneyFeatures.parkingDetails.path;
export const PARKING_DETAILS_ROUTE = `/${JourneyFeatures.parkingDetails.path}`;

// export const ADD_DRIVER = JourneyFeatures.addDriver.path;
// export const EDIT_DRIVER = JourneyFeatures.editDriver.path;
export const MANAGE_DRIVER_INFORMATION = JourneyFeatures.yourDriversDetails.path;
export const MANAGE_DRIVER_INFORMATION_ROUTE = `/${JourneyFeatures.yourDriversDetails.path}`;

export const MANAGE_PERSONAL_DETAILS = JourneyFeatures.personalDetails.path;
export const MANAGE_PERSONAL_DETAILS_ROUTE = `/${JourneyFeatures.personalDetails.path}`;
export const MANAGE_LICENSE_NUMBER = JourneyFeatures.drivingLicenseNumber.path;

export const CHOOSE_MAIN_DRIVER = JourneyFeatures.chooseMainDriver.name;
export const CHOOSE_MAIN_DRIVERS_ROUTE = `/${JourneyFeatures.chooseMainDriver.path}`;

// export const MANAGE_DRIVING_HISTORY = JourneyFeatures.drivingHistory.path;

export const PREMIUM = JourneyFeatures.premium.path;
export const PREMIUM_ROUTE = `/${PREMIUM}`;

// export const REVIEW = JourneyFeatures.review.path;
export const REVIEW_FULL = JourneyFeatures.reviewFull.name;
export const REVIEW_FULL_ROUTE = `/${JourneyFeatures.reviewFull.path}`;

export const REVIEW_DIRECT_DEBIT = JourneyFeatures.reviewDirectDebit.name;
export const REVIEW_DIRECT_DEBIT_ROUTE = `/${JourneyFeatures.reviewDirectDebit.path}`;

export const PAYMENT = JourneyFeatures.payment.path;
export const PAYMENT_DIRECT_DEBIT_DISPLAY = JourneyFeatures.directDebitDisplay.name;
export const PAYMENT_DIRECT_DEBIT_DISPLAY_ROUTE = `/payment/${JourneyFeatures.directDebitDisplay.path}`;

export const PAYMENT_DIRECT_DEBIT_EDIT = JourneyFeatures.directDebitEdit.name;
export const PREFERRED_PAYMENT_DATE = JourneyFeatures.prefferedPaymentDate.name;
export const PAYMENT_DIRECT_DEBIT_EDIT_ROUTE = `/payment/${JourneyFeatures.directDebitEdit.path}`;
export const PREFERRED_PAYMENT_DATE_ROUTE = `/payment/${JourneyFeatures.prefferedPaymentDate.path}`;

export const PAYMENT_CREDIT_CARD = JourneyFeatures.creditCard.name;
export const PAYMENT_CREDIT_CARD_ROUTE = `/payment/${JourneyFeatures.creditCard.path}`;

export const REFUND = JourneyFeatures.refund.path;

export const CONFIRM = JourneyFeatures.confirm.path;
export const CONFIRM_FULL = JourneyFeatures.confirmFull.name;
export const CONFIRM_FULL_ROUTE = `/${JourneyFeatures.confirmFull.path}`;

export const CONFIRM_DIRECT_DEBIT = JourneyFeatures.confirmDirectDebit.name;
export const CONFIRM_DIRECT_DEBIT_ROUTE = `/${JourneyFeatures.confirmDirectDebit.path}`;

export const CONFRIM_RENEWAL_TYPE = JourneyFeatures.confirmAutoRenewal.name;
export const CONFRIM_RENEWAL_TYPE_ROUTE = `/${JourneyFeatures.confirmAutoRenewal.path}`;

export const ALLOCATE = JourneyFeatures.allocate.path;

export const YOUR_CONVICTIONS = JourneyFeatures.yourConvictions.path;
export const YOUR_CONVICTIONS_ROUTE = `/${YOUR_CONVICTIONS}`;

export const YOUR_VEHICLE_USAGE = JourneyFeatures.yourVehicleUsage.path;
export const YOUR_VEHICLE_USAGE_ROUTE = `/${YOUR_VEHICLE_USAGE}`;

export const WHERE_IPARK_MY_CAR = JourneyFeatures.whereIparkMyCar.path;
export const WHERE_IPARK_MY_CAR_ROUTE  = `/${WHERE_IPARK_MY_CAR}`;

export const ERRORS = JourneyFeatures.errors.path;
export const ERRORS_ROUTE = `/${ERRORS}`;
export const ERRORS_LOAD_POLICY_FAILED = `${ERRORS_ROUTE}/load-policy-failed`;
export const ERRORS_POLICY_OUTSIDE_VALID_DURATION = `${ERRORS_ROUTE}/policy-outside-valid-duration`;
export const ERRORS_SESSION_TIMEOUT = `${ERRORS_ROUTE}/session-timeout`;
export const ERRORS_DECLINED = `${ERRORS_ROUTE}/declined`;
export const ERRORS_REFUND = `${ERRORS_ROUTE}/refund-failed`;
export const ERRORS_TRANSACTION_FAILED = `${ERRORS_ROUTE}/transaction-failed`;
export const ERRORS_TRANSACTION_REFUSED = `${ERRORS_ROUTE}/transaction-refused`;
export const ERRORS_PAYMENT_CONTACT_CENTRE = `${ERRORS_ROUTE}/payment-contact-centre`;
export const ERRORS_QUOTE = `${ERRORS_ROUTE}/quote-error`;
export const ERRORS_SUSPENDED_VEHICLE = `${ERRORS_ROUTE}/suspended-vehicle`;
export const ERRORS_GENERIC_ERROR = `${ERRORS_ROUTE}/serivce-issue`;

export const MY_ACCOUNT_POLICY_DASHBOARD_URL = '/my-dashboard#/account-home/policies';
export const MY_ACCOUNT_PAYMENT_URL = '/my-dashboard#/account-home/payments';
export const MY_ACCOUNT_DOCUMENTS_DASHBOARD_URL = '/my-dashboard#/account-home/documents';

export const CANCEL_POLICY = JourneyFeatures.cancelPolicy.path;
export const CANCEL_POLICY_ROUTE = `/${CANCEL_POLICY}`;

export const CANCEL_POLICY_ANOTHER_REASON = JourneyFeatures.anotherReason.path;
export const CANCEL_POLICY_ANOTHER_REASON_ROUTE = `/${CANCEL_POLICY_ANOTHER_REASON}`;